// httpClient.js
import axios from 'axios';

const PROD_BACK = 'https://vector.cloobot.ai/backend'
// const PROD_BACK = 'https://quote.cloobot.ai/backend'
// const PROD_BACK = 'http://vector.cloobot.ai:5005'
// const PROD_BACK = 'http://quote.cloobot.ai:5005'
// const PROD_BACK = 'http://quote.cloobot.ai:5010'
// const PROD_BACK = 'http://quote.cloobot.ai:5007'
//  const PROD_BACK = 'http://20.198.93.27:5010'
// const PROD_BACK = 'http://quote.cloobot.ai:5023'
// const PROD_BACK = 'http://74.225.136.45:5007'
const MICR_SERV = 'https://vector.cloobot.ai/configuration-script';
// const MICR_SERV = 'http://quote.cloobot.ai:5004';

const httpClient = axios.create({
  baseURL: PROD_BACK 
});

const testhttpClient = axios.create({
  baseURL : MICR_SERV
})

const dummyhttpClient = axios.create({
  baseURL : 'http://quote.cloobot.ai:5003/'
})

export const dynApi = (api) =>{
  const dynHttpClient = axios.create();
  return dynHttpClient;
}

export default httpClient;
export {testhttpClient};
export {dummyhttpClient};
export {PROD_BACK};
